import gql from 'graphql-tag';

export default function (params) {
    return gql`
    mutation{
        assignMaster(
        gwid: "${params.gwid}",
        garage_id: "${params.garageId}"
        ){
            errors
            count
            garageGateway{
                id
                device_id
                name
                state
                garage_gateway{
                    id
                    name
                }
            }
        }
    }
    `;
}